import React, { Component } from 'react'
import { IFilterItemProps } from "./models/filter-item.props";
import { OperatorList } from "./models/post.filter.model";
import { Fragment } from "react";
import { FilterItemInputRenderType } from "./models";

interface IState{
    id:string,
    op:string,
    value:string
}

export class FilterItemTime extends Component<IFilterItemProps,IState> {

    constructor(props){
        super(props);
    }

    oprators=OperatorList.time;
    inputRenderType:any=FilterItemInputRenderType.SingleBox;
    
    selectedOptionValue=this.oprators[0].operator;
    selectedValue='';
    

    handleDropDownChange = (event: any) => {       
        let selectedObject=this.oprators.find(x=>x.name==event.target.value);      
        this.selectedOptionValue = selectedObject!=null?selectedObject.operator:"";  
        this.inputRenderType=selectedObject?.renderType;       
        this.brodCastValue();        
    }

    brodCastValue=()=>{
        this.setState({id:this.props.column.columnName,op:this.selectedOptionValue, value:this.selectedValue});
        if(this.inputRenderType==FilterItemInputRenderType.NoBox){
            this.props.onValueChange({column:this.props.column.columnName,op:this.selectedOptionValue,value:this.selectedValue});
        }
        else {
            if(this.selectedOptionValue!=''){
                if(this.selectedValue!=''){
                    this.props.onValueChange({column:this.props.column.columnName,op:this.selectedOptionValue,value:this.selectedValue});
                }else{
                    this.props.clearFilter(this.props.column.columnName);
                }

            }
        }
    }

    handleInputChange=(value1:string)=>{
        if(this.inputRenderType==FilterItemInputRenderType.SingleBox){
            this.selectedValue=value1;
        }else{
            this.selectedValue='';
        }

        this.brodCastValue();
    }

    render(){
    return (
        <div className="form-group mb-3">
            <label>{this.props.column.displayText}</label>
            <div className="row">
                <div className="col-5">
                    <select className="form-control form-control-sm mb-1" name={this.props.column.columnName} onChange={this.handleDropDownChange}>
                        {this.oprators.map((num, index) => {
                            return (
                                <option key={index} value={num.name} className='form-control'>{num.name}</option>
                            );
                        })}

                    </select>
                </div>
                <div className="col pl-0">
                    {(this.inputRenderType === FilterItemInputRenderType.SingleBox) ?

                        (<input type="text" onChange={(e) => this.handleInputChange(e.target.value)} className="form-control form-control-sm" />)
                        : null

                    }
                </div>
            </div>
        </div>
    )
    }

}